var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "timeline" },
    [
      _vm.isMy
        ? _c("div", { staticClass: "updates-bt-block" }, [
            _c("div", [
              _c("div", { staticClass: "text_large" }, [
                _vm._v(_vm._s(_vm.i18n.sale_updates_empty_header()))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text_small text_description text_margin" },
                [_vm._v(_vm._s(_vm.i18n.sale_updates_empty_text()))]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "md-button",
                  {
                    staticClass: "btn md-primary",
                    on: { click: _vm.handleAddClick }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.i18n.sale_updates_add_note_bt()) +
                        "\n      "
                    )
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.items, function(item, i) {
        return _c("timeline-item", {
          key: i,
          staticClass: "timeline__timeline-item",
          attrs: {
            title: item.title,
            date: _vm.i18n.d(item.date),
            message: _vm.linkify(item.message)
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ae6e70d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ae6e70d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/components/UpdatesTab.Timeline.vue
// module id = bGPn
// module chunks = 1